import { render, staticRenderFns } from "./scope68.vue?vue&type=template&id=663663c4&scoped=true"
import script from "./scope68.vue?vue&type=script&lang=js"
export * from "./scope68.vue?vue&type=script&lang=js"
import style0 from "./scope68.vue?vue&type=style&index=0&id=663663c4&prod&lang=scss&scoped=true"
import style1 from "./scope68.vue?vue&type=style&index=1&id=663663c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663663c4",
  null
  
)

export default component.exports